import "core-js/modules/es.array.reverse.js";
var _class, _WebCoverageServiceDescribeCoverageStratum;
import "core-js/modules/web.dom-collections.iterator.js";
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import i18next from "i18next";
import { computed, runInAction, makeObservable } from "mobx";
import CesiumMath from "terriajs-cesium/Source/Core/Math";
import RequestErrorEvent from "terriajs-cesium/Source/Core/RequestErrorEvent";
import URI from "urijs";
import AsyncLoader from "../Core/AsyncLoader";
import isDefined from "../Core/isDefined";
import loadBlob from "../Core/loadBlob";
import loadXML from "../Core/loadXML";
import Result from "../Core/Result";
import TerriaError, { networkRequestError } from "../Core/TerriaError";
import proxyCatalogItemUrl from "../Models/Catalog/proxyCatalogItemUrl";
import ResultPendingCatalogItem from "../Models/Catalog/ResultPendingCatalogItem";
import CommonStrata from "../Models/Definition/CommonStrata";
import createStratumInstance from "../Models/Definition/createStratumInstance";
import LoadableStratum from "../Models/Definition/LoadableStratum";
import StratumOrder from "../Models/Definition/StratumOrder";
import UserDrawing from "../Models/UserDrawing";
import xml2json from "../ThirdParty/xml2json";
import { InfoSectionTraits } from "../Traits/TraitsClasses/CatalogMemberTraits";
import ExportWebCoverageServiceTraits, { WebCoverageServiceParameterTraits } from "../Traits/TraitsClasses/ExportWebCoverageServiceTraits";
import { getName } from "./CatalogMemberMixin";
import ExportableMixin from "./ExportableMixin";
import filterOutUndefined from "../Core/filterOutUndefined";
/** Call WCS GetCapabilities to get list of:
 * - available coverages
 * - available CRS
 * - available file formats
 *
 * Note: not currently used
 */
class WebCoverageServiceCapabilitiesStratum extends LoadableStratum(ExportWebCoverageServiceTraits) {
  static async load(catalogItem) {
    var _json$Contents$Covera, _json$Contents, _json$ServiceMetadata, _json$ServiceMetadata2, _json$ServiceMetadata3, _json$ServiceMetadata4;
    if (!catalogItem.linkedWcsUrl) throw "`linkedWcsUrl` is undefined";
    const url = new URI(catalogItem.linkedWcsUrl).query({
      service: "WCS",
      request: "GetCapabilities",
      version: "2.0.0"
    }).toString();
    const capabilitiesXml = await loadXML(proxyCatalogItemUrl(catalogItem, url));
    const json = xml2json(capabilitiesXml);
    if (!isDefined(json.ServiceMetadata)) {
      throw networkRequestError({
        title: "Invalid GetCapabilities",
        message: "The URL ".concat(url, " was retrieved successfully but it does not appear to be a valid Web Coverage Service (WCS) GetCapabilities document.") + "\n\nEither the catalog file has been set up incorrectly, or the server address has changed."
      });
    }
    const coverages = (_json$Contents$Covera = (_json$Contents = json.Contents) === null || _json$Contents === void 0 ? void 0 : _json$Contents.CoverageSummary) !== null && _json$Contents$Covera !== void 0 ? _json$Contents$Covera : [];
    const formats = (_json$ServiceMetadata = (_json$ServiceMetadata2 = json.ServiceMetadata) === null || _json$ServiceMetadata2 === void 0 ? void 0 : _json$ServiceMetadata2.formatSupported) !== null && _json$ServiceMetadata !== void 0 ? _json$ServiceMetadata : [];
    const crs = (_json$ServiceMetadata3 = (_json$ServiceMetadata4 = json.ServiceMetadata) === null || _json$ServiceMetadata4 === void 0 || (_json$ServiceMetadata4 = _json$ServiceMetadata4.Extension) === null || _json$ServiceMetadata4 === void 0 || (_json$ServiceMetadata4 = _json$ServiceMetadata4.CrsMetadata) === null || _json$ServiceMetadata4 === void 0 ? void 0 : _json$ServiceMetadata4.crsSupported) !== null && _json$ServiceMetadata3 !== void 0 ? _json$ServiceMetadata3 : [];
    return new WebCoverageServiceCapabilitiesStratum(catalogItem, {
      coverages,
      formats,
      crs
    });
  }
  constructor(catalogItem, capabilities) {
    super();
    this.catalogItem = catalogItem;
    this.capabilities = capabilities;
  }
  duplicateLoadableStratum(model) {
    return new WebCoverageServiceCapabilitiesStratum(model, this.capabilities);
  }
}

/** Call WCS DescribeCoverage for a specific coverageId to get:
 * - Native CRS
 * - Native format
 */
_defineProperty(WebCoverageServiceCapabilitiesStratum, "stratumName", "wcsCapabilitiesStratum");
let WebCoverageServiceDescribeCoverageStratum = (_class = (_WebCoverageServiceDescribeCoverageStratum = class WebCoverageServiceDescribeCoverageStratum extends LoadableStratum(ExportWebCoverageServiceTraits) {
  static async load(catalogItem) {
    var _json$CoverageDescrip, _json$CoverageDescrip2, _ref, _json$CoverageDescrip3, _json$CoverageDescrip4, _json$CoverageDescrip5, _json$CoverageDescrip6;
    if (!catalogItem.linkedWcsUrl) throw "`linkedWcsUrl` is undefined";
    if (!catalogItem.linkedWcsCoverage) throw "`linkedWcsCoverage` is undefined";
    const url = new URI(catalogItem.linkedWcsUrl).query({
      service: "WCS",
      request: "DescribeCoverage",
      version: "2.0.0",
      coverageId: catalogItem.linkedWcsCoverage
    }).toString();
    const capabilitiesXml = await loadXML(proxyCatalogItemUrl(catalogItem, url));
    const json = xml2json(capabilitiesXml);
    if (typeof ((_json$CoverageDescrip = json.CoverageDescription) === null || _json$CoverageDescrip === void 0 ? void 0 : _json$CoverageDescrip.CoverageId) !== "string") {
      throw networkRequestError({
        title: "Invalid DescribeCoverage",
        message: "The URL ".concat(url, " was retrieved successfully but it does not appear to be a valid Web Coverage Service (WCS) DescribeCoverage document.") + "\n\nEither the catalog file has been set up incorrectly, or the server address has changed."
      });
    }
    const nativeFormat = (_json$CoverageDescrip2 = json.CoverageDescription) === null || _json$CoverageDescrip2 === void 0 || (_json$CoverageDescrip2 = _json$CoverageDescrip2.ServiceParameters) === null || _json$CoverageDescrip2 === void 0 ? void 0 : _json$CoverageDescrip2.nativeFormat;

    // Try get native CRS from domainSet and then boundedBy
    const nativeCrs = (_ref = (_json$CoverageDescrip3 = (_json$CoverageDescrip4 = json.CoverageDescription) === null || _json$CoverageDescrip4 === void 0 || (_json$CoverageDescrip4 = _json$CoverageDescrip4.domainSet) === null || _json$CoverageDescrip4 === void 0 || (_json$CoverageDescrip4 = _json$CoverageDescrip4.Grid) === null || _json$CoverageDescrip4 === void 0 ? void 0 : _json$CoverageDescrip4.srsName) !== null && _json$CoverageDescrip3 !== void 0 ? _json$CoverageDescrip3 : (_json$CoverageDescrip5 = json.CoverageDescription) === null || _json$CoverageDescrip5 === void 0 || (_json$CoverageDescrip5 = _json$CoverageDescrip5.boundedBy) === null || _json$CoverageDescrip5 === void 0 || (_json$CoverageDescrip5 = _json$CoverageDescrip5.EnvelopeWithTimePeriod) === null || _json$CoverageDescrip5 === void 0 ? void 0 : _json$CoverageDescrip5.srsName) !== null && _ref !== void 0 ? _ref : (_json$CoverageDescrip6 = json.CoverageDescription) === null || _json$CoverageDescrip6 === void 0 || (_json$CoverageDescrip6 = _json$CoverageDescrip6.boundedBy) === null || _json$CoverageDescrip6 === void 0 || (_json$CoverageDescrip6 = _json$CoverageDescrip6.Envelope) === null || _json$CoverageDescrip6 === void 0 ? void 0 : _json$CoverageDescrip6.srsName;
    return new WebCoverageServiceDescribeCoverageStratum(catalogItem, {
      nativeFormat,
      nativeCrs
    });
  }
  constructor(catalogItem, coverage) {
    super();
    this.catalogItem = catalogItem;
    this.coverage = coverage;
    makeObservable(this);
  }
  get linkedWcsParameters() {
    return createStratumInstance(WebCoverageServiceParameterTraits, {
      outputCrs: this.coverage.nativeCrs,
      outputFormat: this.coverage.nativeFormat
    });
  }
  duplicateLoadableStratum(model) {
    return new WebCoverageServiceDescribeCoverageStratum(model, this.coverage);
  }
}, _defineProperty(_WebCoverageServiceDescribeCoverageStratum, "stratumName", "wcsDescribeCoverageStratum"), _WebCoverageServiceDescribeCoverageStratum), _applyDecoratedDescriptor(_class.prototype, "linkedWcsParameters", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "linkedWcsParameters"), _class.prototype), _class);
function ExportWebCoverageServiceMixin(Base) {
  var _class2;
  let ExportWebCoverageServiceMixin = (_class2 = class ExportWebCoverageServiceMixin extends ExportableMixin(Base) {
    constructor() {
      super(...arguments);
      _defineProperty(this, "_wcsCapabilitiesLoader", new AsyncLoader(this.loadWcsCapabilities.bind(this)));
      _defineProperty(this, "_wcsDescribeCoverageLoader", new AsyncLoader(this.loadWcsDescribeCoverage.bind(this)));
      makeObservable(this);
    }
    get isLoadingWcsMetadata() {
      return this._wcsCapabilitiesLoader.isLoading || this._wcsDescribeCoverageLoader.isLoading;
    }
    async loadWcsMetadata(force) {
      const results = await Promise.all([
      // Disable GetCapabilities loader until we need it
      // this._wcsCapabilitiesLoader.load(force),
      this._wcsDescribeCoverageLoader.load(force)]);
      return Result.combine(results, {
        message: "Failed to load `".concat(getName(this), "` WebCoverageService metadata"),
        importance: -1
      });
    }
    async loadWcsCapabilities() {
      const capabilities = await WebCoverageServiceCapabilitiesStratum.load(this);
      runInAction(() => this.strata.set(WebCoverageServiceCapabilitiesStratum.stratumName, capabilities));
    }
    async loadWcsDescribeCoverage() {
      const describeCoverage = await WebCoverageServiceDescribeCoverageStratum.load(this);
      runInAction(() => this.strata.set(WebCoverageServiceDescribeCoverageStratum.stratumName, describeCoverage));
    }

    // ExportableMixin overrides
    get _canExportData() {
      return isDefined(this.linkedWcsCoverage) && isDefined(this.linkedWcsUrl);
    }
    _exportData() {
      return new Promise((resolve, reject) => {
        const terria = this.terria;
        runInAction(() => terria.pickedFeatures = undefined);
        let rectangle;
        const userDrawing = new UserDrawing({
          terria: this.terria,
          messageHeader: "Click two points to draw a retangle extent.",
          buttonText: "Download Extent",
          onPointClicked: () => {
            if (userDrawing.pointEntities.entities.values.length >= 2) {
              var _userDrawing$otherEnt;
              rectangle = userDrawing === null || userDrawing === void 0 || (_userDrawing$otherEnt = userDrawing.otherEntities) === null || _userDrawing$otherEnt === void 0 || (_userDrawing$otherEnt = _userDrawing$otherEnt.entities) === null || _userDrawing$otherEnt === void 0 || (_userDrawing$otherEnt = _userDrawing$otherEnt.getById("rectangle")) === null || _userDrawing$otherEnt === void 0 || (_userDrawing$otherEnt = _userDrawing$otherEnt.rectangle) === null || _userDrawing$otherEnt === void 0 || (_userDrawing$otherEnt = _userDrawing$otherEnt.coordinates) === null || _userDrawing$otherEnt === void 0 ? void 0 : _userDrawing$otherEnt.getValue(this.terria.timelineClock.currentTime);
            }
          },
          onCleanUp: async () => {
            if (isDefined(rectangle)) {
              if (!this.linkedWcsUrl || !this.linkedWcsCoverage) return;
              return this.downloadCoverage(rectangle).then(resolve).catch(reject);
            } else {
              reject("Invalid drawn extent.");
            }
          },
          allowPolygon: false,
          drawRectangle: true
        });
        userDrawing.enterDrawMode();
      });
    }

    /** Generate WCS GetCoverage URL */
    getCoverageUrl(bbox) {
      try {
        var _this$linkedWcsParame, _this$linkedWcsParame2;
        let error = undefined;
        if (this.linkedWcsParameters.duplicateSubsetValues && this.linkedWcsParameters.duplicateSubsetValues.length > 0) {
          let message = "WebCoverageService (WCS) only supports one value per dimension.\n\n  ";

          // Add message for each duplicate subset
          message += this.linkedWcsParameters.duplicateSubsetValues.map(subset => "- Multiple dimension values have been set for `".concat(subset.key, "`. WCS GetCoverage request will use the first value (`").concat(subset.key, " = \"").concat(subset.value, "\"`)."));
          error = new TerriaError({
            title: "Warning: export may not reflect displayed data",
            message,
            importance: 1
          });
        }

        // Make query parameter object
        const query = {
          service: "WCS",
          request: "GetCoverage",
          version: "2.0.0",
          coverageId: this.linkedWcsCoverage,
          format: this.linkedWcsParameters.outputFormat,
          // Add subsets for bbox, time and dimensions
          subset: ["Long(".concat(CesiumMath.toDegrees(bbox.west), ",").concat(CesiumMath.toDegrees(bbox.east), ")"), "Lat(".concat(CesiumMath.toDegrees(bbox.south), ",").concat(CesiumMath.toDegrees(bbox.north), ")"),
          // Turn subsets into `key=(value)` format
          ...filterOutUndefined(((_this$linkedWcsParame = this.linkedWcsParameters.subsets) !== null && _this$linkedWcsParame !== void 0 ? _this$linkedWcsParame : []).map(subset => subset.key && subset.value ? "".concat(subset.key, "(").concat(
          // Wrap string values in double quotes
          typeof subset.value === "string" ? "\"".concat(subset.value, "\"") : subset.value, ")") : undefined))],
          subsettingCrs: "EPSG:4326",
          outputCrs: this.linkedWcsParameters.outputCrs
        };

        // Add linkedWcsParameters.additionalParameters ontop of query object
        Object.assign(query, ((_this$linkedWcsParame2 = this.linkedWcsParameters.additionalParameters) !== null && _this$linkedWcsParame2 !== void 0 ? _this$linkedWcsParame2 : []).reduce((q, current) => {
          if (typeof current.key === "string") {
            q[current.key] = current.value;
          }
          return q;
        }, {}));
        return new Result(new URI(this.linkedWcsUrl).query(query).toString(), error);
      } catch (e) {
        return Result.error(e);
      }
    }

    /** This function downloads WCS coverage for a given bbox (in radians)
     * It will also create a "pendingWorkbenchItem" with loading indicator and short description.
     */
    async downloadCoverage(bbox) {
      // Create pending workbench item
      const now = new Date();
      const timestamp = "".concat(now.getFullYear().toString().padStart(4, "0"), "-").concat((now.getMonth() + 1).toString().padStart(2, "0"), "-").concat(now.getDate().toString().padStart(2, "0"), "T").concat(now.getHours().toString().padStart(2, "0"), ":").concat(now.getMinutes().toString().padStart(2, "0"), ":").concat(now.getSeconds().toString().padStart(2, "0"));
      const pendingWorkbenchItem = new ResultPendingCatalogItem("WCS: ".concat(getName(this), " ").concat(timestamp), this.terria);
      try {
        runInAction(() => {
          pendingWorkbenchItem.loadPromise = new Promise(() => {});
          pendingWorkbenchItem.loadMetadata();

          // Add WCS loading metadata message to shortReport
          pendingWorkbenchItem.setTrait(CommonStrata.user, "shortReport", i18next.t("models.wcs.asyncResultLoadingMetadata", {
            name: getName(this),
            timestamp: timestamp
          }));
        });
        pendingWorkbenchItem.terria.workbench.add(pendingWorkbenchItem);

        // Load WCS metadata (DescribeCoverage request)
        (await this.loadWcsMetadata()).throwIfError();

        // Get WCS URL
        // This will throw an error if URL is undefined
        // It will raise an error if URL is defined, but an error has occurred
        const urlResult = this.getCoverageUrl(bbox);
        const url = urlResult.throwIfUndefined({
          message: "Failed to generate WCS GetCoverage request URL",
          importance: 2 // Higher importance than error message in `getCoverageUrl()`
        });
        urlResult.raiseError(this.terria, "Error occurred while generating WCS GetCoverage URL");
        runInAction(() => {
          // Add WCS "pending" message to shortReport
          pendingWorkbenchItem.setTrait(CommonStrata.user, "shortReport", i18next.t("models.wcs.asyncPendingDescription", {
            name: getName(this),
            timestamp: timestamp
          }));

          // Create info section from URL query parameters
          const info = createStratumInstance(InfoSectionTraits, {
            name: "Inputs",
            content: "<table class=\"cesium-infoBox-defaultTable\">".concat(Object.entries(new URI(url).query(true)).reduce((previousValue, _ref2) => {
              let [key, value] = _ref2;
              return "".concat(previousValue, "<tr><td style=\"vertical-align: middle\">").concat(key, "</td><td>").concat(value, "</td></tr>");
            }, ""), "</table>")
          });
          pendingWorkbenchItem.setTrait(CommonStrata.user, "info", [info]);
        });
        const blob = await loadBlob(proxyCatalogItemUrl(this, url));
        runInAction(() => pendingWorkbenchItem.terria.workbench.remove(pendingWorkbenchItem));
        return {
          name: "".concat(getName(this), " clip.tiff"),
          file: blob
        };
      } catch (error) {
        var _error, _error$response$type;
        if (error instanceof TerriaError) {
          throw error;
        }

        // Attempt to get error message out of XML response
        if (error instanceof RequestErrorEvent && isDefined((_error = error) === null || _error === void 0 || (_error = _error.response) === null || _error === void 0 ? void 0 : _error.type) && ((_error$response$type = error.response.type) === null || _error$response$type === void 0 ? void 0 : _error$response$type.indexOf("xml")) !== -1) {
          try {
            const xml = new DOMParser().parseFromString(await error.response.text(), "text/xml");
            if (xml.documentElement.localName === "ServiceExceptionReport" || xml.documentElement.localName === "ExceptionReport") {
              var _xml$getElementsByTag, _xml$getElementsByTag2, _xml$getElementsByTag3;
              const message = (_xml$getElementsByTag = (_xml$getElementsByTag2 = xml.getElementsByTagName("ServiceException")) === null || _xml$getElementsByTag2 === void 0 || (_xml$getElementsByTag2 = _xml$getElementsByTag2[0]) === null || _xml$getElementsByTag2 === void 0 ? void 0 : _xml$getElementsByTag2.innerHTML) !== null && _xml$getElementsByTag !== void 0 ? _xml$getElementsByTag : (_xml$getElementsByTag3 = xml.getElementsByTagName("ows:ExceptionText")) === null || _xml$getElementsByTag3 === void 0 || (_xml$getElementsByTag3 = _xml$getElementsByTag3[0]) === null || _xml$getElementsByTag3 === void 0 ? void 0 : _xml$getElementsByTag3.innerHTML;
              if (isDefined(message)) {
                /* eslint-disable-next-line no-ex-assign */
                error = message;
              }
            }
          } catch (xmlParseError) {
            console.log("Failed to parse WCS response");
            console.log(xmlParseError);
          }
        }
        throw new TerriaError({
          sender: this,
          title: i18next.t("models.wcs.exportFailedTitle"),
          message: i18next.t("models.wcs.exportFailedMessageII", {
            error
          })
        });
      } finally {
        runInAction(() => pendingWorkbenchItem.terria.workbench.remove(pendingWorkbenchItem));
      }
    }
    dispose() {
      super.dispose();
      this._wcsCapabilitiesLoader.dispose();
      this._wcsDescribeCoverageLoader.dispose();
    }
  }, _applyDecoratedDescriptor(_class2.prototype, "isLoadingWcsMetadata", [computed], Object.getOwnPropertyDescriptor(_class2.prototype, "isLoadingWcsMetadata"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "_canExportData", [computed], Object.getOwnPropertyDescriptor(_class2.prototype, "_canExportData"), _class2.prototype), _class2);
  return ExportWebCoverageServiceMixin;
}
(function (_ExportWebCoverageServiceMixin2) {
  function isMixedInto(model) {
    return model && "loadWcsMetadata" in model && typeof model.loadWcsMetadata === "function";
  }
  _ExportWebCoverageServiceMixin2.isMixedInto = isMixedInto;
  StratumOrder.addLoadStratum(WebCoverageServiceCapabilitiesStratum.stratumName);
  StratumOrder.addLoadStratum(WebCoverageServiceDescribeCoverageStratum.stratumName);
})(ExportWebCoverageServiceMixin || (ExportWebCoverageServiceMixin = {}));
export default ExportWebCoverageServiceMixin;